<template>
  <v-app>

    <v-main class="pa-0"  style="background-color: #F0ECE4;">
      <v-app-bar
          app
          absolute
          color="#F0ECE4"
          :elevation="2"
          ref="cabecera"
      >
        <v-row justify="center" align="center">
          <v-col cols="11" xl="9" lg="9">
            <router-link :to="{ name: 'lgportada'}">
              <v-img
                  alt="Lg Logo"

                  contain
                  min-width="100"
                  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/logo.png"
                  width="100"
              /></router-link>
          </v-col>
        </v-row>


      </v-app-bar>

      <v-container fluid class="pt-6">
          <section>
            <v-row justify="center" align="center">
              <v-col cols="12" lg="3" xl="3" md="6" sm="6">
                <h1 >Crea tu Espacio</h1>
              </v-col>
            </v-row>
          </section>
        <section >
      <v-row justify="center" align="center">
        <v-col style="display:none;" cols="5" lg="1" xl="1" md="2" sm="6">
          <router-link :to="{ name: 'lgportada'}">    <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/volver.png" /></router-link>
        </v-col>
        <v-col cols="8" lg="2" xl="2" md="4" sm="6">
         <center>
           <v-menu
             open-on-hover
             offset-y
            >
             <template v-slot:activator="{ attrs, on }">

         <v-btn
             v-bind="attrs"
             v-on="on"
             text
             ref="menutipo"
             style="color: #A50035;  font-size:xx-large; font-family: 'LGSmartUI' !important; letter-spacing: normal !important; font-weight: bold !important; font-style: normal !important; text-transform: none; text-decoration: underline;"
         >Dormitorio</v-btn
         > </template>
         <v-list>
           <v-list-item style="color: #A50035;  font-size:medium; font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important; letter-spacing: normal !important;  text-transform: none;" @click="eligetv" class="lgnormal">TV</v-list-item>
           <v-list-item style="color: #A50035;  font-size:medium; font-family: 'LGSmartUI' !important; font-weight: normal !important; font-style: normal !important; letter-spacing: normal !important;  text-transform: none;" @click="eligeaudio" class="lgnormal" >Audio</v-list-item>
         </v-list>

         </v-menu>
         </center>
          <v-overlay v-model="paso1"  >
          <v-card v-bind:style="stylePaso1"><v-card-text> <v-row>
            <v-col>
              <v-icon>fas fa-arrow-left</v-icon> Paso 1 : Sitúa el mouse sobre Dormitorio y elige el tipo de producto LG
            </v-col>
            </v-row></v-card-text>
          <v-card-actions>
            <v-btn text @click="irpaso2">Siguiente</v-btn>
          </v-card-actions></v-card>
          </v-overlay>
          <v-overlay v-model="paso2"  >
            <v-card v-bind:style="stylePaso2"><v-card-text> <v-row>
              <v-col>
                <v-icon>fas fa-arrow-up</v-icon>  Paso 2 : Elige el nivel de tecnología del producto que buscas.
              </v-col>
            </v-row></v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                    <v-btn text @click="irpaso1">Anterior</v-btn>

                  </v-col>
                  <v-col>
                    <v-btn text @click="irpaso3">Siguiente</v-btn>

                  </v-col>
                </v-row>
              </v-card-actions></v-card>
          </v-overlay>
          <v-overlay v-model="paso3"  >
            <v-card v-bind:style="stylePaso3"><v-card-text> <v-row>
              <v-col>
                <v-icon>fas fa-arrow-left</v-icon>  Paso 3 : Elige el tamaño del producto que buscas.
              </v-col>
            </v-row></v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                    <v-btn text @click="irpaso2">Anterior</v-btn>

                  </v-col>
                  <v-col>
                    <v-btn text @click="irpaso4">Siguiente</v-btn>

                  </v-col>
                </v-row>
              </v-card-actions></v-card>
          </v-overlay>
          <v-overlay v-model="paso4"  >
            <v-card v-bind:style="stylePaso4"><v-card-text> <v-row>
              <v-col>
                Paso 4 : Conoce la información del producto y el precio.<v-icon>fas fa-arrow-right</v-icon>
              </v-col>
            </v-row></v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                    <v-btn text @click="irpaso3">Anterior</v-btn>

                  </v-col>
                  <v-col>
                    <v-btn text @click="paso4=false">Listo</v-btn>

                  </v-col>
                </v-row>
              </v-card-actions></v-card>
          </v-overlay>
        </v-col>
        <v-col cols="8" lg="2" xl="2" md="3" sm="6" class="hidden-xs-only hidden-sm-only">
          <center> <router-link :to="{ name: 'lgcocina'}" style="color: #848381;text-decoration: none; font-size:xx-large; font-weight: bold; " class="lgbold">Cocina/Lavandería</router-link></center>
        </v-col>
        <v-col cols="8" lg="2" xl="2" md="3" sm="6" class="hidden-xl-only hidden-lg-only hidden-md-only">
          <center> <router-link :to="{ name: 'lgcocina'}" style="color: #848381;text-decoration: none; font-size:xx-large; font-weight: bold; " class="lgbold">Cocina <br/> Lavandería</router-link></center>
        </v-col>
        <v-col cols="8" lg="2" xl="2" md="3" sm="6">
          <center>   <router-link :to="{ name: 'lgsala'}" style="color: #848381; text-decoration: none; font-size:xx-large; font-weight: bold; " class="lgbold"> Sala</router-link></center>
        </v-col>
      </v-row>
          <v-row  justify="center" align="center">
            <v-col  cols="12" sm="12" md="8" lg="9" style="background-color: transparent !important;">

              <v-row justify="center" align="center" >

                <v-col cols="11">
                  <v-row>
                   <v-col cols="4">
                    <v-row justify="start" align="center">
                      <v-col xl="3" lg="5" md="5"  style="font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;" class="lgnormal">
                        Menos tecnológico                      </v-col>
                    </v-row>
                  </v-col>
                    <v-col cols="4" style=" color: #A50035; font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;">
                    <center style=" color: #A50035; font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;" class="lgnormal">Gamma Media</center>
                    </v-col>
                    <v-col cols="4"  style="text-align: end;">
                      <v-row justify="end" align="center">
                        <v-col xl="3" lg="5" md="5" style="font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;" class="lgnormal">
                    Más tecnológico
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="11">
                  <v-slider @change="cmbprod(2)" color="#DDD9D0" :thumb-size="72" thumb-color="#A50035" track-color="#DDD9D0" v-model="gamma" :min="minimo" :max="maximo" :step="1" ></v-slider>
                </v-col>
              </v-row>
              <v-row align="stretch" justify="center" class="hidden-sm-only hidden-xs-only">
                <v-col col="1" lg="1" md="1" class="d-flex flex-column">
                  <v-row align="end" justify="end">
                    <v-col style="text-align: end; color: #A50035; font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;" class="lgnormal">
                     Tamaño Grande
                    </v-col>
                  </v-row>
                  <v-row class="pa-0 ma-0">
                    <v-col>  <v-slider @change="cmbprod(1)" class="lgnormal" color="#DDD9D0" :thumb-size="36" thumb-color="#A50035" track-color="#DDD9D0" vertical height="100%" style="height: 100%; color: #A50035;" v-model="tamanio" :min="minimo" :max="maximo" :step="1" label="Tamaño Mediano"></v-slider>
                    </v-col>
                  </v-row>  <v-row class="pa-0 ma-0" align="start" justify="start">
                    <v-col style="text-align: end; color: #A50035; font-family: 'LGSmartUI' !important;" class="lgnormal">
                      Tamaño Pequeño
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="11" lg="11" md="11" class="d-flex flex-column">
                  <div  class="background-image-container" @click="handleBackgroundClick">

              <img ref="baseImage" width="100%" :src="backgroundImageUrl" />
     <overlay-image
         v-for="(overlay, index) in overlays"
         :key="index"
         :overlay="overlay"
         :overlay-index="index"
         :background-image-size="backgroundImageSize"
         @overlay-moved="handleOverlayMoved"
         @overlay-contextmenu="handleOverlayContextMenu"
         @contextproduct="handleOverlayContextProducto"
     />
              </div>
                </v-col>
          </v-row>

              <v-row align="center" justify="center" class="hidden-xl-only hidden-lg-only hidden-md-only">
                <v-col col="11"  >
                  <v-row>
                    <v-col cols="12" class="productoreg lgnormal">
                      <center style=" color: #A50035; font-family: 'LGSmartUI' !important; font-weight: normal !important; font-style: normal !important;" class="lgnormal">Tamaño</center>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="4">
                          <v-row justify="start" align="center">
                            <v-col xl="3" lg="5" md="5"  style="font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;" class="lgnormal">
                              Tamaño Pequeño                      </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" style=" color: #A50035; font-family: 'LGSmartUI' !important;" class="lgnormal">
                          <center style=" color: #A50035; font-family: 'LGSmartUI' !important;" class="lgnormal">Mediano</center>
                        </v-col>
                        <v-col cols="4"  style="text-align: end;">
                          <v-row justify="end" align="center">
                            <v-col xl="3" lg="5" md="5" style="text-align:end;font-family: 'LGSmartUI' !important;" class="lgnormal">
                              Tamaño Grande
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">  <v-slider @change="cmbprod(1)" color="#DDD9D0" :thumb-size="36" thumb-color="#A50035" track-color="#DDD9D0"  height="100%" style=" color: #A50035;" v-model="tamanio" :min="minimo" :max="maximo" :step="1" ></v-slider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="11" lg="11" md="11" >
                  <div  class="background-image-container" @click="handleBackgroundClick">

                    <img ref="baseImageMob" width="100%" :src="backgroundImageUrl" />
                    <overlay-image
                        v-for="(overlay, index) in overlays"
                        :key="index"
                        :overlay="overlay"
                        :overlay-index="index"
                        :background-image-size="backgroundImageSize"
                        @overlay-moved="handleOverlayMoved"
                        @overlay-contextmenu="handleOverlayContextMenu"
                        @contextproduct="handleOverlayContextProducto"
                    />
                  </div>
                </v-col>


              </v-row>

            </v-col>
            <v-col  cols="12" sm="12" md="6" lg="2" >
              <v-row>
                <v-col>
                  <v-img height="200px" contain :src="producto.image" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold" >Nombre:</h2>
                </v-col>

                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.name}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold">Modelo:</h2>
                </v-col>

                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.modelo}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold">Precio: </h2>
                </v-col>
                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                <span style="text-decoration:line-through;" class="lgnormal"> {{producto.precio}}</span> {{producto.preciodscto}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold"> Descripción: </h2>
                </v-col>

              </v-row>
              <v-row>
                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.descripcion}}
                </v-col>

              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="10">

                  <img alt="boton"
                       src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/btncupon.png"
                       style="cursor: pointer;"
                       @click="scrollToSection"
                  />
                </v-col>

              </v-row>

            </v-col>
          </v-row>

          <v-row style="display: none;" justify="center" align="center">
  <v-col cols="12" sm="12" md="11" lg="11">
    <v-card class="custom-rounded-card">
      <v-card-text>
    <carousel-3d :controls-visible="true" :clickable="false" :height="360">
          <slide
              v-for="(prod, index) in productosfilt"
              :key="index"
              :index="index"

          >
            <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
              <h3 style="color:#000000 !important;text-align: center;">{{prod.modelo}}</h3>
              <img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="prod.image"  @click="cambiaprod(prod)">
            </template>
          </slide>
    </carousel-3d>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
          <v-row justify="center" align="center"  >
            <v-col cols="12" sm="12" md="11" lg="11">
              <v-card class="custom-rounded-card"><v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                  <v-row  ref="targetSection" justify="center" align="center" class=" ma-0 ma-lg-12 ma-xl-12 ma-md-10" >
                    <v-col cols="12" style="color: #8D8C89; font-size: larger; " class="lgnormal">
                      <h2 style="text-align: center;color:#A50035;font-family: 'LGSmartUI' !important;" class="lgnormal">CON TUS COMPRAS EN LG.COM PARTICIPA DEL SORTEO DE ESTOS PREMIOS</h2><br/>
                      <p style="font-family: 'LGSmartUI' !important;" class="lgnormal">Premio 1: Decoración del espacio de tu casa valorizado en S/. 10,000 con la asesoría de Yesenia Schulz</p>
                      <p style="font-family: 'LGSmartUI' !important;" class="lgnormal">Premio 2: Mesa de centro de Bo Concept Store</p>
                      <p style="font-family: 'LGSmartUI' !important;" class="lgnormal">Completa tus datos, usa el cupón de descuento y listo, ya estas participando</p>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0  pa-1">
                      <v-text-field outlined  v-bind:style="styleComponent" class="lgnormal" v-model="editedItem.nombre" :label="$t('formularios.nombres')" :rules="[rules.required]"> </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" class="lgnormal" v-model="editedItem.apellidoPaterno" :label="$t('formularios.ApPaterno')" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" class="lgnormal" v-model="editedItem.dni"  label="DNI / Carnet de Extranjeria" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" class="lgnormal" v-model="editedItem.email" label="Correo" :rules="emailRules" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">

                      <v-text-field class="ma-0 lgnormal" outlined v-bind:style="styleComponent" v-model="editedItem.telefono" label="Celular" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-row>

                        <v-col  cols="2" sm="2" md="2" class="mt-0 pa-1">

                          <v-checkbox
                              v-model="editedItem.aceptoCondicion"
                              :rules="[v => !!v || 'Debes aceptar para continuar']"

                              required
                              style="color: #1E3D90 !important;"
                              color="#1E3D90"
                              class="ma-0 lgnormal"
                          ></v-checkbox> </v-col>
                        <v-col  cols="9" sm="9" md="9" class="mt-0 pa-1 lgnormal" style="font-family: 'LGSmartUI' !important;"> Acepta los <a href="https://www.lg.com/pe/tycdecoratuespacio" target="_blank">Términos y Condiciones</a>
                        </v-col></v-row>

                    </v-col>


                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-alert
                          :value="alerterror"
                          color="red"
                          dark
                          dismissible
                          border="top"
                          transition="scale-transition"
                      >
                        {{error}}
                      </v-alert>
                    <center>  <v-btn color="#A50035" style="color: #FFFFFF; padding: 25px !important; height: 50px !important; border-radius: 15px !important; font-size: 25px;"  class="lgnormal" @click="saveImage">PARTICIPAR</v-btn>
                    </center>   </v-col>
                  </v-row>
                </v-form>
              </v-card-text></v-card>

              <v-dialog  v-model="terminos" width="50%" >
                <v-card color="#F0ECE4">
                  <v-card-text class="pa-6">
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminostitulo.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminosprimero.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminoscodigos.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminosdos.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="3">
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/lifesgood.png"></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-dialog  :scrollable="false" v-model="diseniodialog" content-class="cdises" width="70%" >
                <center><v-row justify="center" align="center" @click="diseniodialog = false">
                  <v-col cols="8" @click="diseniodialog = false">
              <v-img width="100%" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/popup.png" @click="diseniodialog = false" /></v-col></v-row></center>
              </v-dialog>
            </v-col>
          </v-row>

        </section>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import OverlayImage from "@/components/componente/OverlayImage.vue";
import { Carousel3d, Slide } from 'vue-carousel-3d';
import lgproductos from "@/assets/json/lgproductos.json";

// optional style for arrows & dots
export default {
  name: "lgdormitorio",
  components: {OverlayImage, Carousel3d,
    Slide},
  title: "LG",
  data () {
    return {
      selectedOverlayIndex: null,
      currentIndex: 0,
      itemsToShow: 4,
      categoria:"cuarto",
      valid:true,
      valida:false,
      paso1:true,
      paso2:false,
      paso3:false,
      paso4:false,
      maximo:6,
      minimo:1,
      tiposdoc: [{id:1,tipoDocumento:"DNI",paisId:173}],
      terminos:false,
      imagendiseniada:'',
      rules: {
        required: value => !!value || 'Requerido.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Mail invalido.'
        },
      },
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      alerterror:false,
      error:'',
      gamma:6,
      tamanio:6,
      backgroundImageSize: { width: 0, height: 0 },
      producto:{
        name:'',
        image:'',
        width:'',
        modelo:'',
        descripcion:'',
        precio:''
      },

      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      prodc:'',
      diseniodialog:false,
      categorias:[{nombre:"Sala",codigo:"sala"},{nombre:"Cocina",codigo:"cocina"},{nombre:"Dormitorio",codigo:"cuarto"}],
      backgroundImageUrl:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/ambiente1.jpg',
      ambientesfiltr:[],
      ambiente:{nombre:"cuarto1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png",categoria:"cuarto",ancho:"550",anchoMob:"250"},
      ambientes:[{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"sala2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"cocina1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cocina2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png",categoria:"cuarto",ancho:"550",anchoMob:"250"},
        {nombre:"cuarto2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"}],
      alertnuevo: false,
      overlays:[],
      tagevento:'',
      productos:[],
      instrucciones:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instrucciones.png',
      stylePagina: {
        fontColor:'black',
        fontFamily: 'LGSmartUI',
        color: '#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleComponent:{
        color:'#000000',
        backgroundColor:'#FFFFFFF',
        fontFamily: 'LGSmartUI'
      },
      stylePaso1:{
        top: '-25% !important',
        left: '-100px'
      },
      stylePaso2:{
        top: '-25% !important',
        left: '-100px'
      },
      stylePaso3:{
        top: '-25% !important',
        left: '-100px'
      },
      stylePaso4:{
        top: '-25% !important',
        left: '-100px'
      },
      styleCabecera:{
        color:'#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleForm:{
        color:'#000000',
        marginTop:'0px !important',
        fontFamily: 'LGSmartUI'
      },
      btnPag: {
        backgroundColor: '#1E3D90',
        color:'white'
      },
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  'lgexperiencia';
    this.getImageSize();

  this.calcularPuntoMedio();
    this.productos = lgproductos;
    this.escogecat();
    if(!this.$device.mobile){
     this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.png'
      this.instrucciones = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instrucciones.png'

    }else{
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png'
      this.instrucciones = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instruccionesM.png'

    }
  },
  methods: {
    irpaso2(){
      this.paso1 = false
      this.paso2 = true
      this.paso3 = false
      this.paso4 = false
    },
    irpaso3(){
      this.paso1 = false
      this.paso3 = true
      this.paso2 = false
      this.paso4 = false
    },
    irpaso4(){
      this.paso1 = false
      this.paso3 = false
      this.paso2 = false
      this.paso4 = true
    },
    irpaso1(){
      this.paso1 = true
      this.paso2 = false
      this.paso3 = false
      this.paso4 = false
    },
    calcularPuntoMedio() {
      const anchoPantalla = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const altoPantalla = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      let puntoMedio = {
        x: anchoPantalla / 2,
        y: altoPantalla / 2
      };
      const cabecera = this.$refs.cabecera
      const cabeceraheight  =   cabecera.$el.offsetHeight;
      const menutipo = this.$refs.menutipo
      const elmenutipo = menutipo.$el
      this.stylePaso1.top = ( (-1 * puntoMedio.y) + (cabeceraheight *1.5)) +'px'
      console.log(menutipo)
      this.$nextTick(() => {
      const menuitipowidth = elmenutipo.offsetWidth;
      const menuitipoleft = elmenutipo.offsetLeft;
      console.log(puntoMedio.x)
      console.log(menuitipoleft + menuitipowidth - puntoMedio.x/2)
      this.stylePaso1.left = ( menuitipoleft  - puntoMedio.x/2) + 'px'

      this.stylePaso2.top = ( (-1 * puntoMedio.y) + (cabeceraheight *5)) +'px'
      this.stylePaso2.left = (menuitipowidth) + 'px'
      this.stylePaso3.top =  (puntoMedio.y / 2) + 'px'
      this.stylePaso3.left = (-1* menuitipoleft) + 'px'

        this.stylePaso4.top =  (puntoMedio.y / 3) + 'px'
        this.stylePaso4.left = (menuitipoleft/2) + 'px'
      });
    },
    eligetv(){
      this.minimo = 1;
      this.maximo = 6;
      this.prodc = "TV";
      this.gamma = 6
      this.tamanio = 6
      this.cmbprod(2)
    },
    scrollToSection() {
      this.$nextTick(() => {
        const targetElement = this.$refs.targetSection;

        if (targetElement && targetElement.$el) {
          const targetPosition = targetElement.$el.offsetTop;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    },
    eligeaudio(){
      this.minimo = 1;
      this.maximo = 12;
      this.gamma= 1
      this.tamanio = 2
      this.prodc = "Audio";
      this.cmbprod(2)

    },
    cmbprod(it){
      console.log(this.prodc)
      if(this.prodc==="Audio"){
        console.log(it)
        if(it===1){
          console.log('tamanio')
          console.log(this.categoria)
          console.log(this.prodc)
          console.log(this.tamanio)
          let itm = this.productos.find(item=> item.categoria === this.categoria && item.producto === this.prodc && item.tamanio === this.tamanio  )
          console.log(itm)
          if (itm !==undefined){
            this.gamma = itm.gamma
            this.eligeprod(itm)
          }
        }else{
          console.log('gamma')
          console.log(this.categoria)
          console.log(this.prodc)
          console.log(this.gamma)
          let itm = this.productos.find(item=> item.categoria === this.categoria && item.producto === this.prodc &&  item.gamma === this.gamma )
          console.log(itm)
          if (itm !==undefined){
            this.tamanio = itm.tamanio
            this.eligeprod(itm)
          }
        }
      }else{
        let itm = this.productos.find(item=> item.categoria=== this.categoria && item.producto === this.prodc && item.tamanio === this.tamanio && item.gamma === this.gamma )
        console.log(itm)
        if (itm !==undefined){
          this.eligeprod(itm)
        }
      }

    },
    async loadImageFromS3(imageUrl) {
      try {
        const response = await axios.get(imageUrl+'?not-from-cache-please`', {
          headers: { "Cache-Control": "no-cache" },
          responseType: 'blob'
        });
        return response.data;
      } catch (error) {
        console.error('Error al cargar la imagen desde S3:', error);
        return null;
      }
    },
    handleOverlayContextMenu(index) {
      // Eliminar el elemento del array overlays en función del índice
      this.overlays.splice(index, 1);
    },
    handleOverlayContextProducto(model) {
      this.producto = this.productos.find(x=>x.id === model );
    },
    verterminos(){
      this.terminos = true;
    },
    calculateNewHeight(originalWidth, originalHeight, newWidth) {
      // Asegurarse de que los valores sean números válidos
      const originalWidth2 = parseFloat(originalWidth) || 1;
      const  originalHeight2 = parseFloat(originalHeight) || 1;
      const   newWidth2 = parseFloat(newWidth) || 1;

      // Calcular el nuevo alto manteniendo las mismas proporciones (aspect ratio)
      const newHeight = (newWidth2 / originalWidth2) * originalHeight2;
      return newHeight;
    },
    async saveImage() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      var imgr = '';
      if(this.$device.mobile){
        canvas.width  = this.$refs.baseImageMob.width;
        canvas.height = this.$refs.baseImageMob.height;
        imgr = this.$refs.baseImageMob.src
      }else{
        canvas.width = this.$refs.baseImage.width;
        canvas.height = this.$refs.baseImage.height;
        imgr = this.$refs.baseImage.src
      }
      try {


        const imageBlob = await this.loadImageFromS3(imgr);

        if(imageBlob){
          // Configura el tamaño del canvas según el tamaño de las imágenes
          const img = new Image();
          img.src = URL.createObjectURL(imageBlob);

          await new Promise((resolve) => {
            img.onload = resolve;
          });

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);


          await Promise.all(
              this.overlays.map(async (overlayImageUrl) => {
                const overlayImageBlob = await this.loadImageFromS3(overlayImageUrl.imageUrl);

                if (overlayImageBlob) {
                  const imgR = new Image();
                  imgR.src = URL.createObjectURL(overlayImageBlob);

                  await new Promise((resolve) => {
                    imgR.onload = resolve;
                  });
                  const newwidth = overlayImageUrl.width.slice(0, -2);

                  ctx.drawImage(
                      imgR,
                      overlayImageUrl.position.x,
                      overlayImageUrl.position.y,
                      newwidth,
                      this.calculateNewHeight(imgR.width, imgR.height, newwidth)
                  );
                }
              })
          );

          // Obtén la imagen combinada como una URL de datos
          const combinedImageUrl = canvas.toDataURL('image/jpeg');
          await this.grabarexp(combinedImageUrl);


          //   Crea un enlace para descargar la imagen
          //  //  const link = document.createElement('a');
          //  link.href = combinedImageUrl;
          //   link.download = 'imagen_combinada.png';

          // Simula un clic en el enlace para iniciar la descarga
          //  link.click();

        }
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
      }

    },
    async resizeImage(blob, maxSizeInBytes) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Redimensionar la imagen manteniendo la proporción original
          const maxWidth = 800; // Puedes ajustar el ancho máximo según tus necesidades
          const maxHeight = 800; // Puedes ajustar la altura máxima según tus necesidades

          let newWidth = img.width;
          let newHeight = img.height;

          if (newWidth > maxWidth) {
            newHeight *= maxWidth / newWidth;
            newWidth = maxWidth;
          }

          if (newHeight > maxHeight) {
            newWidth *= maxHeight / newHeight;
            newHeight = maxHeight;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          // Obtener el Blob de la imagen redimensionada
          canvas.toBlob((resizedBlob) => {
            if (resizedBlob) {
              if (resizedBlob.size <= maxSizeInBytes) {
                resolve(resizedBlob);
              } else {
                reject(new Error(`La imagen redimensionada sigue siendo demasiado grande.`));
              }
            } else {
              reject(new Error('Error al crear el Blob de la imagen redimensionada.'));
            }
          }, 'image/jpeg'); // Puedes ajustar el formato de la imagen según tus preferencias
        };
        img.onerror = () => {
          reject(new Error('Error al cargar la imagen.'));
        };
      });
    },
    async getImageBlob(imageUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            reject(new Error(`Error al obtener la imagen: ${xhr.status}`));
          }
        };
        xhr.onerror = () => {
          reject(new Error('Error al obtener la imagen.'));
        };
        xhr.open('GET', imageUrl);
        xhr.send();
      });
    },

    async grabarexp(combinedImageUrl){

      const originalBlob = await this.getImageBlob(combinedImageUrl);
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 megabytes
      if (originalBlob.size > maxSizeInBytes) {
        const resizedBlob = await this.resizeImage(originalBlob, maxSizeInBytes);
        if (resizedBlob) {
          var bodyFormData = new FormData();
          this.diseniodialog= true
          this.imagendiseniada = resizedBlob;
          this.editedItem.fechaNacimiento = '01-01-1992'

          this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
          let eevve = 32
          bodyFormData.append("estadoEventoId",eevve)
          bodyFormData.append("persona",JSON.stringify(this.editedItem))
          bodyFormData.append("tagevento",this.tagevento)
          bodyFormData.append("file",resizedBlob)
          this.rest = true
          axios
              .post('tickets/grabar/formulario/lg',bodyFormData,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                  'Content-Type':'multipart/form-data'
                }
              })
              .then(response => {
                let ticketMin = response.data;
                console.log(ticketMin)
                this.imagendiseniada= ticketMin.depositoTicket.voucher
                this.editedItem = this.defaultdItem
                this.alertnuevo = true
                this.rest = false
                this.overlay = false

              })
              .catch((error)  => {
                console.error(error);
                this.overlay = false
                this.diseniodialog= true
              });

        } else {
          console.error('Error al redimensionar la imagen.');
          return;
        }
      }else{
        var bodyFormData2 = new FormData();
        this.overlay = true;
        this.editedItem.fechaNacimiento = '01-01-1992'
        this.diseniodialog= true
        this.imagendiseniada = originalBlob;
        this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
        let eevve = 32
        bodyFormData2.append("estadoEventoId",eevve)
        bodyFormData2.append("persona",JSON.stringify(this.editedItem))
        bodyFormData2.append("tagevento",this.tagevento)
        bodyFormData2.append("file",originalBlob)
        this.rest = true
        axios
            .post('tickets/grabar/formulario/lg',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
                'Content-Type':'multipart/form-data'
              }
            })
            .then(response => {
              let ticketMin = response.data;
              console.log(ticketMin)
              this.imagendiseniada= ticketMin.depositoTicket.voucher
              this.editedItem = this.defaultdItem
              this.alertnuevo = true
              this.rest = false
              this.overlay = false
              this.valid = true
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false
            });
      }
    },
    eligeprod(item){
      var ancho = 0;
      var anchoimg = 0;
      var altoimg = 0;
      var imagen;
      var newX = 0;
      var newY = 0;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
        imagen = this.$refs.baseImageMob;
      }else{
        ancho = this.ambiente.ancho
        imagen = this.$refs.baseImage;
      }
      anchoimg = imagen.offsetWidth;
      altoimg = imagen.offsetHeight;

      let newWidth = Number(item.width) * anchoimg / Number(ancho)
      if(this.$device.mobile){
        newX = item.positionM.x * anchoimg
        newY = item.positionM.y * altoimg
      }else{

        newX = item.position.x * anchoimg
        newY = item.position.y * altoimg
      }
          let obj = {
          imageUrl: item.image,
          width: newWidth+"px",
          producto: item.producto,
          position: { x: newX, y: newY },
          id: item.id
        }
      const doesExistPrd = this.overlays.some(obj => obj.producto === item.producto);
      console.log(doesExistPrd)
  if (!doesExistPrd){
    console.log('No Existe prod')

    const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
    console.log(doesExist)
     if (!doesExist) {
          console.log(obj)
         this.overlays.push(obj)
       }
  }else{
    this.overlays = this.overlays.filter(function(elemento) {
      console.log(elemento)
      return elemento.producto !== item.producto;
    })
    this.overlays.push(obj)

  }
  console.log(this.overlays )
      this.producto = item
    },
    cambiaprod(item){
      let ancho = 0;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
      }else{
        ancho = this.ambiente.ancho
      }
      const imagen = this.$refs.baseImage;
      console.log(ancho)
      // Capturamos el ancho de la imagen una vez que se ha cargado
      const anchoimg = imagen.offsetWidth;
      console.log(anchoimg)
      /*   let newWidth = Number(item.width) * anchoimg / Number(ancho)
          let obj = {
          imageUrl: item.image,
          width: newWidth+"px",
          position: { x: item.position.x, y: item.position.y },
          id: item.id
        }
         const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
     if (!doesExist) {
         this.overlays.push(obj)
       }
   */
      this.producto = item
    },
    escogecat(){
      this.ambientesfiltr = this.ambientes.filter(item=> item.categoria === this.categoria)

    },

    escogeamb(){
      if(this.$device.mobile){
        this.backgroundImageUrl = this.ambiente.urlMob

      }else{
        this.backgroundImageUrl = this.ambiente.url

      }
    },
    getImageSize() {
      const img = new Image();
      img.src = this.backgroundImageUrl;
      img.onload = () => {
        this.backgroundImageSize = {
          width: img.width,
          height: img.height
        };
      };
    },
    handleBackgroundClick() {
      if (this.selectedOverlayIndex !== null) {
        // Clear selection when clicking on the background
        this.selectedOverlayIndex = null;
      }
      },
    handleOverlayMoved(overlayIndex, newPosition) {
      // Update the position of the overlay in the overlays array

        console.log('llega el movimiento')
        this.overlays[overlayIndex].position = newPosition;

    }

  },
  computed: {
    carouselStyles() {
      const translateX = -this.currentIndex * (100 / this.itemsToShow);
      return `transform: translateX(${translateX}%)`;
    },
    productosfilt() {
      let productosfilt =  [...this.productos];
      productosfilt = productosfilt.filter(item => item.categoria === this.categoria)
/*
      if(this.gamma){
        productosfilt = productosfilt.filter(item=> item.gamma === this.gamma)
      }
      if(this.tamanio){
        productosfilt = productosfilt.filter(item=> item.tamanio === this.tamanio)
      } */
      return productosfilt;
    }
  }
}
</script>

<style >
.grecaptcha-badge{
  display: none;
}
body{
  background: #B69C96;
  overflow-y: hidden;
  overflow-x: hidden;
}
.background-image-container {
  position: relative;
}
.custom-rounded-card {
  border-radius: 35px !important; /* Ajusta el valor para cambiar la cantidad de redondeo */
}
.carousel-3d-slide img{
  width: auto !important;
  height: 200px !important;
}

.v-input .v-label{
  color:#A50035 !important;
}
.carousel-3d-slide{
  border: none !important;
  background-color: #FFFFFF !important;
  text-align: center;

}

.v-slider--vertical{
  min-height: 500px !important;
}

.v-slider--vertical .v-slider__track-container{
  height: 100% !important;
  width: 10px !important;
}

.v-slider__track-container{
  height: 10px !important;
}

.cdises{
  overflow: hidden !important;
  overflow-y: hidden !important;
  box-shadow: none !important;
}

.productoreg{
  color:#A50035;
  font-family: 'LGSmartUI' !important;
  font-size: medium;
  font-weight: bold;
}
.v-label{
  color:#A50035 !important;
  font-family: 'LGSmartUI' !important;
  font-size: medium !important;
}
.lgbold{
  font-family: 'LGSmartUI' !important;font-weight: bold !important; font-style: normal !important;
}
.lgnormal{
  font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;
}
.circle {
  background-color:#fff;
  height: 120px;
  width: 120px;
  display: block;
  border: 5px solid #00baff;
  border-radius: 100px;
  position: absolute;
  bottom: 0;
  z-index: 1;
  animation-name:circle;
  animation-duration:1s;
  animation-timing-function:linear;
  animation-delay:0s;
  animation-iteration-count:infinite;
  animation-direction:normal;
  animation-play-state:running;
  -webkit-animation-name:circle;
  -webkit-animation-duration:1s;
  -webkit-animation-timing-function:linear;
  -webkit-animation-delay:0s;
  -webkit-animation-iteration-count:infinite;
  -webkit-animation-direction:normal;
  -webkit-animation-play-state:running;
}
.fa {
  font-size: 42px;
  color: #00baff;
  bottom: 27px;
  position: absolute;
  left: 50%;
  margin-left: -18px;
  animation-name:arrow;
  animation-duration:1s;
  animation-timing-function:linear;
  animation-delay:0s;
  animation-iteration-count:infinite;
  animation-direction:normal;
  animation-play-state:running;
  -webkit-animation-name:arrow;
  -webkit-animation-duration:1s;
  -webkit-animation-timing-function:linear;
  -webkit-animation-delay:0s;
  -webkit-animation-iteration-count:infinite;
  -webkit-animation-direction:normal;
  -webkit-animation-play-state:running;
}
</style>